import React from 'react';

import { Text } from '@actual-app/components/text';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';

import { Link } from '#components/common/Link';

export type Atalho = { titulo: string; descricao: string; para: string };

/** Um grupo de atalhos da tela de Ajustes (ver `finapp/AtalhosAjustes.tsx`). */
export function GrupoDeAtalhos({
  titulo,
  atalhos,
}: {
  titulo: string;
  atalhos: Atalho[];
}) {
  return (
    <View style={{ gap: 8 }}>
      <Text
        style={{
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: '.02em',
          textTransform: 'uppercase',
          color: theme.pageTextSubdued,
        }}
      >
        {titulo}
      </Text>

      {atalhos.map(atalho => (
        <View key={atalho.para} style={{ gap: 2 }}>
          <Link
            variant="internal"
            to={atalho.para}
            style={{ fontSize: 15, fontWeight: 500 }}
          >
            {atalho.titulo}
          </Link>
          <Text style={{ fontSize: 13, color: theme.pageTextSubdued }}>
            {atalho.descricao}
          </Text>
        </View>
      ))}
    </View>
  );
}
